import React, { useState, useEffect } from "react";
import Styles from "./ConfigContainer.module.css";
import { useSelector } from "react-redux";
import { ReactComponent as PaymentBlock } from "../../../../assets/images/Payment_Block.svg";
import { ReactComponent as PaymentRupee2 } from "../../../../assets/images/Payment_Rupee2.svg";
import { ReactComponent as PaymentRupee3 } from "../../../../assets/images/Payment_Rupee3.svg";
import { ReactComponent as PaymentSchedule } from "../../../../assets/images/Payment_Schedule.svg";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import { useNavigate } from "react-router-dom";
import Charges from "../../../Modals/ConGen/Charges/Charges";
import Skeleton from "@mui/material/Skeleton"; // <-- MUI Skeleton import
import ChargeView from "../../ChargeView/ChargeView";

const admin = [
  {
    type: "contract",
    name: "Contract",
    svg: PaymentSchedule,
    nav: "/wallet_contract",
  },
  {
    type: "add_charges",
    name: "Add User Charges",
    svg: PaymentRupee2,
  },
  {
    type: "create_charges",
    name: "Create Charges",
    svg: PaymentRupee2,
  },
];

const user = [
  {
    type: "view_charges",
    name: "View Charges",
    svg: PaymentRupee2,
    viewCharges: true,
  },
  {
    type: "contract",
    name: "Contracts",
    svg: PaymentSchedule,
    nav: "/wallet_contract",
  },
  {
    type: "view_transactions",
    name: "Transactions",
    svg: PaymentSchedule,
    nav: "/wallet_transaction",
  },
];

const formatIndianNumber = (num) => {
  if (num == null) return "₹0";
  return "₹" + num.toLocaleString("en-IN");
};

const ConfigContainer = () => {
  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole
  ).toLowerCase();
  const data = useSelector((state) => state?.paymentSlice?.walletAccountActive);
  const navigation = useNavigate();
  const [charges, setCharges] = useState(false);

  // Loader state
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading, replace with your actual loading logic if needed
    if (data !== undefined) {
      setLoading(false);
    }
  }, [data]);

  const handleViewCharges = async () => {
    setCharges(true);
  };

  return (
    <>
      {charges && (
        <ChargeView
          open={charges}
          handleClose={() => setCharges(false)}
          userLevel={true}
        />
      )}
      <div
        className={`display_flex_column_row_16 ${Styles.configMainContainer}`}
      >
        {loading ? (
          <>
            <div className={`display_flex_column ${Styles.balanceContainer}`}>
              <div
                className={`display_flex_row_gap_8_only ${Styles.amountContainerMain} ${Styles.allContainerPadding}`}
              >
                <Skeleton variant="circular" width={56} height={56} />
                <div className={`display_flex_column_gap_4`}>
                  <Skeleton variant="text" width={80} height={18} />
                  <Skeleton variant="text" width={80} height={24} />
                </div>
              </div>
              <div
                className={`${Styles.amountAlterContier}  ${Styles.allContainerPadding} display_flex_row_gap_8_only ${Styles.vidNumberContainer}`}
              >
                <Skeleton variant="text" width={100} height={18} />
              </div>
            </div>
            <div
              className={`display_flex_column ${Styles.balanceMainContainer}`}
            >
              <div
                className={`display_flex_column_row_16 ${Styles.balanceDetailContainer}`}
              >
                <div
                  className={`display_flex_row_gap_8_only ${Styles.amountContainerMain}  ${Styles.allContainerPadding}`}
                >
                  <Skeleton variant="circular" width={56} height={56} />
                  <div className={`display_flex_column_gap_4`}>
                    <Skeleton variant="text" width={80} height={18} />
                    <Skeleton variant="text" width={80} height={24} />
                  </div>
                </div>
                <div
                  className={`display_flex_row_gap_8_only ${Styles.amountContainerMain}  ${Styles.allContainerPadding}`}
                >
                  <Skeleton variant="circular" width={56} height={56} />
                  <div className={`display_flex_column_gap_4`}>
                    <Skeleton variant="text" width={80} height={18} />
                    <Skeleton variant="text" width={80} height={24} />
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : !data ? (
          <div className={Styles.noData}>No wallet data available</div>
        ) : (
          <>
            <div className={`display_flex_column ${Styles.balanceContainer}`}>
              <div
                className={`display_flex_row_gap_8_only ${Styles.amountContainerMain} ${Styles.allContainerPadding}`}
              >
                <PaymentRupee3 style={{ height: "56px", width: "56px" }} />
                <div className={`display_flex_column_gap_4`}>
                  <div className={Styles.vidBal}>VID Balance</div>
                  <div className={Styles.vidValue}>
                    {formatIndianNumber(
                      data?.amountRemaining + data?.amountBlocked
                    )}
                  </div>
                </div>
              </div>
              <div
                className={`${Styles.amountAlterContier}  ${Styles.allContainerPadding} display_flex_row_gap_8_only ${Styles.vidNumberContainer}`}
              >
                <div>VID:</div>
                <div>{data?.walletCompanyCode}</div>
              </div>
            </div>
            <div
              className={`display_flex_column ${Styles.balanceMainContainer}`}
            >
              <div
                className={`display_flex_column_row_16 ${Styles.balanceDetailContainer}`}
              >
                <div
                  className={`display_flex_row_gap_8_only ${Styles.amountContainerMain}  ${Styles.allContainerPadding}`}
                >
                  <PaymentRupee2 style={{ height: "56px", width: "56px" }} />
                  <div className={`display_flex_column_gap_4`}>
                    <div className={Styles.purseBalance}>Purse Balance</div>
                    <div className={Styles.purseBalanceValue}>
                      {formatIndianNumber(data?.amountRemaining)}
                    </div>
                  </div>
                </div>
                <div
                  className={`display_flex_row_gap_8_only ${Styles.amountContainerMain}  ${Styles.allContainerPadding}`}
                >
                  <PaymentBlock style={{ height: "56px", width: "56px" }} />
                  <div className={`display_flex_column_gap_4`}>
                    <div className={Styles.purseBlock}>Purse Block</div>
                    <div className={Styles.purseBalanceValue}>
                      {formatIndianNumber(data?.amountBlocked)}
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={`display_flex_column_row_16 ${Styles.balanceAlterContainer}`}
              >
                {(role === "consumer" || role === "generator"
                  ? user
                  : admin
                )?.map((ele, idx) => {
                  const SvgIcon = ele.svg;
                  return (
                    <div
                      className={`display_flex_row  ${Styles.allContainerPadding}`}
                      onClick={() =>
                        ele?.viewCharges
                          ? handleViewCharges()
                          : ele?.nav
                          ? navigation(ele?.nav)
                          : ""
                      }
                      key={idx}
                    >
                      <div
                        className={`display_flex_row_gap_8 ${Styles.svgContainer}`}
                      >
                        <SvgIcon style={{ height: "32px", width: "32px" }} />
                        <div>{ele?.name}</div>
                      </div>
                      <ArrowOutwardIcon
                        className={Styles.svgArrow}
                        style={{ fontSize: "14px", color: "#6f6d7c" }}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default ConfigContainer;
